export const BUSINESS = {
  name: "TIRE INFLUENCERS",
  tagline: "Performance Rubber. Wholesale Prices.",
  phoneDisplay: "+1 (647) 241-8362",
  phoneRaw: "+16472418362",
  whatsapp: "16472418362",
  email: "influencerstire@gmail.com",
  address: "600 Harrop Dr, Milton, ON L9T 3H2",
  mapQuery: "600 Harrop Dr, Milton, ON L9T 3H2",
  hours: [
    { day: "Mon – Fri", time: "7:30 AM – 7:00 PM" },
    { day: "Saturday", time: "8:00 AM – 5:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
  stats: [
    { value: "18K+", label: "Tires in stock" },
    { value: "40+", label: "Premium brands" },
    { value: "24H", label: "Fitment turnaround" },
    { value: "4.9", label: "Customer rating" },
  ],
};
